import DateFnsUtils from "@date-io/date-fns";
import CssBaseline from "@material-ui/core/CssBaseline";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import {ThemeProvider} from "@material-ui/styles";
import {QueryClientProvider} from "@tanstack/react-query";
import {SnackbarProvider} from "notistack";
import React from "react";
import ReactDOM from "react-dom";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import {Provider} from "react-redux";
import store from "store/store";
import {initObservability} from "tools/observability";
import {installStaleChunkRecovery} from "tools/stale-chunk";
import theme from "tools/theme";
import ErrorBoundary from "view/components/ErrorBoundary";
import AppTolgeeProvider from "view/components/AppTolgeeProvider";
import {queryClient} from "./queryClient";
import App from "./view";

// Initialise observability BEFORE the React tree mounts so any error during
// bootstrap (provider setup, lazy imports, the very first render) is
// captured. Datadog and OpenReplay run in parallel while OpenReplay is
// being A/B-tested; each has its own activation gate (env/build checks).
initObservability();

// Auto-recover from stale chunks after a deploy: when the bundle in this
// tab references chunk hashes the new deploy replaced, force a reload to
// pull the fresh index.html instead of letting users land on a white screen.
installStaleChunkRecovery();

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <AppTolgeeProvider>
          <QueryClientProvider client={queryClient}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Provider store={store}>
                <DndProvider backend={HTML5Backend}>
                  <SnackbarProvider>
                    <CssBaseline />
                    <App />
                  </SnackbarProvider>
                </DndProvider>
              </Provider>
            </MuiPickersUtilsProvider>
          </QueryClientProvider>
        </AppTolgeeProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);
